document.addEventListener('DOMContentLoaded', function() {

    // Filtres catégories filtrés par le ACF dédié
    const elements = document.querySelectorAll('[data-blog-cat]');
    let values = [];
    elements.forEach(element => {
        const dataCatBlog = element.getAttribute('data-blog-cat');
        values = values.concat(dataCatBlog.split(' '));
    });
    const optionValues = document.querySelectorAll('.blog-cat [data-option-value]');
    optionValues.forEach(option => {
        if (!values.includes(option.getAttribute('data-option-value'))) {
            option.style.display = 'none';
        }
    });
});